import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { IconButton, Grid, Box } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';
const PaymentGatewaysEnum = require('../../common/payment-gateways').default;

const styles = theme => ({
  root: {
    width: "100%",
  },
  padding10px: {
    padding: '10px'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const TransactionSortObj = {
  firstname: { tableName: 'customers', sortColumn: 'first_name' },
  lastname: { tableName: 'customers', sortColumn: 'last_name' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  pucode: { tableName: 'prescriptions_master', sortColumn: 'pucode' },
  transaction_id: { tableName: '', sortColumn: 'sales_id' },
  trans_status: { tableName: '', sortColumn: 'trans_status' },
  masked_card_number: { tableName: '', sortColumn: 'masked_card_number' },
  card_type: { tableName: '', sortColumn: 'card_type' },
  card_brand: { tableName: '', sortColumn: 'card_brand' },
  entry_type: { tableName: '', sortColumn: 'entry_type' },
  reference_id: { tableName: '', sortColumn: 'reference_id' },
  payment_date: { tableName: '', sortColumn: 'payment_date' },
  payment_type: { tableName: '', sortColumn: 'payment_type' },
  currency_code: { tableName: '', sortColumn: 'currency_code' },
  approved_amt: { tableName: '', sortColumn: 'approved_amt' },
  type: { tableName: '', sortColumn: 'type' },
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'payment_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowsPerPage: 25,
      boxvalues: [],
      accountValues: [],
      loader: false,
      selectedObject: null,
      isButtonDisabled: false,
      SelectedPaymentGateway: '',
      confirmationForRefund: false,
      reversalConfirmationMessage: '',
      isHidden: false,
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/iPayTransactionReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['StoreID', 'FirstName', 'LastName', 'Store', 'Box', 'PickUpCode', 'TransactionID', 'TransationStatus', 'CardNumber', 'CardType', 'CardBrand', 'EntryType', 'ReferenceID', 'PaymentDate/Time', 'PaymentType', 'CurrencyCode', 'TotalAmount', 'Type']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.firstname,
                  i.lastname,
                  i.store,
                  i.box,
                  i.pucode,
                  i.transaction_id,
                  i.trans_status,
                  i.masked_card_number,
                  i.card_type,
                  i.card_brand,
                  i.entry_type,
                  i.reference_id,
                  i.payment_date ? this.convertToTimeZone(i && i.payment_date) : '',
                  (i && i.selected_payment_gateway === PaymentGatewaysEnum.AXIAMED && i.type === "hpp") ? "" : (i.payment_type || i.card_type),
                  i.currency_code,
                  i.approved_amt ? '$' + parseFloat(i.approved_amt).toFixed(2) : '$0.00',
                  i.type
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "iPayTransactionReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      })
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          this.setState({ boxvalues: boxlist });
          this.setState({ loader: false });
        });
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues)
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = (boxvalues, accountValues) => {
    const self = this;
    return {
      getRows(params) {
        console.log(params.request)
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set fromdate and todate
        if (filterObject.payment_date) {
          const dateValue = filterObject.payment_date;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

        if (isStoreNotSelected === true || isBoxNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0)
          self.setState({ data: [], isButtonDisabled: true })
        } else { // store or box is selected
          apiCall()
        }

        function apiCall() {
          self.setState({ loader: true });
          self.setState({ apiCallInProgress: true });
          fetch(process.env.REACT_APP_BASEURL + 'getiPayTransaction', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  LinkValueRenderer = (params) => {
    return (
      <a
        href=''
        title='Print Receipt'
        style={{
          color: '#385cad',
          fontWeight: 500,
          textDecoration: 'none ',
          fontSize: '1rem',
        }}
        onClick={(event) =>
          this.handlePUcodeClick(event, params.value)
        }
      >
        {' '}
        {params.value}
      </a>
    )
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  handlePUcodeClick = (event, transaction_id) => {
    event.preventDefault();
    const selectedObject = this.state.data.find(x => (x.transaction_id || x.trans_id) === transaction_id);
    const ReceiptObj = selectedObject && JSON.parse(selectedObject.receipt);
    let paymentDetail;
    if (selectedObject.selected_payment_gateway === PaymentGatewaysEnum.GLOBAL_PAYMENTS) {
      if (ReceiptObj !== null && ReceiptObj !== 'null' && ReceiptObj !== '') {
        const paymentDetailsobj = ReceiptObj && ReceiptObj.labeled_attributes;
        let payamount = paymentDetailsobj && paymentDetailsobj.total_amount && paymentDetailsobj.total_amount.value;
        let totalpaidamount = payamount && payamount.replace("USD", "");
        paymentDetail = {
          username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
          ReceiptNumber: ReceiptObj && ReceiptObj.id,
          Batch: paymentDetailsobj && paymentDetailsobj.batch_number && paymentDetailsobj.batch_number.value,
          TransID: paymentDetailsobj && paymentDetailsobj.transaction_id && paymentDetailsobj.transaction_id.value,
          OrderID: paymentDetailsobj && paymentDetailsobj.reference_id && paymentDetailsobj.reference_id.value,
          TransType: paymentDetailsobj && paymentDetailsobj.transaction_type && paymentDetailsobj.transaction_type.value,
          Date_Time: paymentDetailsobj && paymentDetailsobj.transaction_datetime && paymentDetailsobj.transaction_datetime.value,
          CardType: paymentDetailsobj && paymentDetailsobj.card_type && paymentDetailsobj.card_type.value,
          CardNumber: paymentDetailsobj && paymentDetailsobj.masked_card_number && paymentDetailsobj.masked_card_number.value,
          EntryMethod: paymentDetailsobj && paymentDetailsobj.entry_method && paymentDetailsobj.entry_method.value,
          ApprovalCode: paymentDetailsobj && paymentDetailsobj.approval_code && paymentDetailsobj.approval_code.value,
          TotalAmount: totalpaidamount,
          order_id: selectedObject && selectedObject.order_id,
          customer_id: selectedObject && selectedObject.customer_id
        }
      } else {
        paymentDetail = {
          username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
          ReceiptNumber: '',
          Batch: selectedObject && selectedObject.batch_no,
          TransID: selectedObject && (selectedObject.transaction_id || selectedObject.trans_id),
          OrderID: selectedObject && selectedObject.reference_id,
          TransType: '',
          Date_Time: selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : '',
          CardType: selectedObject && selectedObject.card_type,
          CardNumber: selectedObject && (selectedObject.masked_card_number || selectedObject.account_no),
          EntryMethod: selectedObject && selectedObject.entry_type,
          ApprovalCode: selectedObject && selectedObject.approved_code,
          TotalAmount: selectedObject && selectedObject.approved_amt ? '$' + parseFloat(selectedObject.approved_amt).toFixed(2) : '$0.00',
          order_id: selectedObject && selectedObject.order_id,
          customer_id: selectedObject && selectedObject.customer_id
        }
      }
      this.setState({ detailDialogOpen: true, selectedObject: paymentDetail, SelectedPaymentGateway: selectedObject.selected_payment_gateway });
    } else {
      paymentDetail = {
        username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
        trans_id: (selectedObject && selectedObject.trans_id) || (selectedObject && selectedObject.transaction_id),
        trans_status: selectedObject && selectedObject.trans_status,
        reference_id: selectedObject && selectedObject.reference_id,
        type: selectedObject && selectedObject.type,
        remote_id: selectedObject && selectedObject.remote_id,
        payment_date: selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : '',
        card_holder: (selectedObject && selectedObject.card_holder) || "",
        card_type: selectedObject && selectedObject.card_type,
        masked_card_number: selectedObject && selectedObject.masked_card_number,
        card_expiration_date: `${selectedObject && selectedObject.exp_month}/${selectedObject && selectedObject.exp_year}`,
        input_method: selectedObject && selectedObject.entry_type,
        amount: selectedObject && selectedObject.approved_amt ? '$' + parseFloat(selectedObject.approved_amt).toFixed(2) : '$0.00',
        selected_payment_gateway: selectedObject && selectedObject.selected_payment_gateway,
        box_id: selectedObject && selectedObject.boxid,
        order_id: selectedObject && selectedObject.order_id,
        customer_id: selectedObject && selectedObject.customer_id
      }
      this.setState({ detailDialogOpen: true, selectedObject: paymentDetail, SelectedPaymentGateway: selectedObject.selected_payment_gateway });
    }
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null })
  }
  PrintDetails = () => {
    setTimeout(() => {
      window.print();
      this.setState({ detailDialogOpen: false, selectedObject: null })
    }, 1000);
  }

  returnReceiptDetails = (selectedObject, classes) => {
    const { t } = this.props;
    let { SelectedPaymentGateway } = this.state;
    if ((SelectedPaymentGateway === null ||
      SelectedPaymentGateway === 'null' ||
      SelectedPaymentGateway === undefined ||
      SelectedPaymentGateway === 'undefined' ||
      SelectedPaymentGateway === '')) {
      SelectedPaymentGateway = PaymentGatewaysEnum.GLOBAL_PAYMENTS
    }
    switch (SelectedPaymentGateway) {
      case PaymentGatewaysEnum.GLOBAL_PAYMENTS: return (<TableBody>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.BatchHash")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.Batch}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TransID}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReceiptNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.ReceiptNumber}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TransType}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.DateTime")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.Date_Time}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.CardType}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.CardNumber}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.EntryMethod")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.EntryMethod}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ApprovalCode")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.ApprovalCode}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TotalAmount")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TotalAmount}</TableCell>
        </TableRow>
      </TableBody>);
      case PaymentGatewaysEnum.AXIAMED: return (<TableBody>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.trans_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionStatus")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.trans_status}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReferenceID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.reference_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TypeHPP")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.type}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.RemoteID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.remote_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.DateTime")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.payment_date}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardHolderName")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_holder}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_type}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.masked_card_number}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ExpirationDate")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_expiration_date}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.EntryMethod")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.input_method}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TotalAmount")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.amount}</TableCell>
        </TableRow>
      </TableBody>);
      default: return (<TableBody>
        <TableRow>
          <TableCell colSpan={5}>{t("Report.iPay.NoDataFound")}</TableCell>
        </TableRow>
      </TableBody>);
    }
  }

  handleConfirmRefundOpenOrClose = (e) => {
    this.setState({
      confirmationForRefund: !this.state.confirmationForRefund,
      reversalConfirmationMessage: 'Are you sure you want to refund order amount?',
      isHidden: false,
      isButtonDisabled: false,
      detailDialogOpen: false
    });
  }

  initRefund = () => {
    const { selectedObject } = this.state;
    console.log(selectedObject);
    const payLoad = {
      boxId: selectedObject && selectedObject.box_id,
      reference_id: selectedObject && selectedObject.reference_id,
    }
    this.setState({ isButtonDisabled: true });
    fetch(process.env.REACT_APP_BASEURL + "axia-med/transaction/reversal", {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payLoad)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(async (reversalResponseObject) => {
      console.log(reversalResponseObject && reversalResponseObject.data)
      if (reversalResponseObject && reversalResponseObject.data && reversalResponseObject.data.statusCode === 500) {
        this.setState({
          reversalConfirmationMessage: 'Payment has already been refunded to your account!',
          isHidden: true,
          isButtonDisabled: false
        });
      } else if (reversalResponseObject && reversalResponseObject.data && reversalResponseObject.data.statusCode === 200) {
        await this.syncAxiaMedsRefundWithCloud(reversalResponseObject.data, (selectedObject && selectedObject.order_id), (selectedObject && selectedObject.customer_id));
      }
    });
  }

  syncAxiaMedsRefundWithCloud = async (data, order_id, customer_id) => {
    let object = this.prepareReversalObject(data, order_id, customer_id);
    fetch(process.env.REACT_APP_BASEURL + "axia-med/hpps/sync/reversal/entries", {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(object)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(reversalSyncResponseObject => {
      if (reversalSyncResponseObject && reversalSyncResponseObject.sent === true) {
        this.setState({
          reversalConfirmationMessage: 'Payment has been refunded successfully!',
          isHidden: true,
          isButtonDisabled: false
        });
      }
      this.BindGrid();
    });
  }

  prepareReversalObject = (data, order_id, customer_id) => {
    let parsedJson;
    if (data && data.data) {
      parsedJson = JSON.parse(data.data);
    }
    const paymentObject = {
      customer_id: customer_id,
      order_id: order_id,
      is_duplicate: false,
      payment_date: parsedJson && parsedJson.created_at,
      host_response_code: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.host_code,
      result: 0,
      result_message: parsedJson && parsedJson.gateway_result_text,
      approved_amt: parsedJson && parsedJson.amount,
      batch_no: 0,
      batch_amt: 0,
      approved_code: '',
      account_no: '',
      avs_response_code: '',
      card_holder_name: '',
      card_type: parsedJson && parsedJson.card_type + '-' + parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.card_type,
      card_brand: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.card_brand,
      card_brand_short: '',
      language: '',
      alias: '',
      entry_type: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.entry_mode,
      receipt_text: "",
      exp_month: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.expiration_date && parsedJson.gateway_response.card_details.card_data.expiration_date.substr(0, 2),
      exp_year: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.expiration_date && parsedJson.gateway_response.card_details.card_data.expiration_date.substr(2, 2),
      trans_id: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.original_transaction && parsedJson.gateway_response.original_transaction.transaction_id,
      is_paid: parsedJson && parsedJson.transaction_status === "approved" ? true : false,
      host_response_description: '',
      trans_status: parsedJson && parsedJson.transaction_status,
      cardsecurity_response: '',
      processor_response: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.processor,
      masked_card_number: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.card_number,
      currency_code: parsedJson && parsedJson.card_type + '-' + parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.issuing_country_code_a2,
      reference_id: parsedJson && parsedJson.gateway_reference_number,
      payment_type: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.payment_type,
      receipt: JSON.stringify(parsedJson),
      links: '',
      sales_id: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.original_transaction && parsedJson.gateway_response.original_transaction.transaction_id,
      card_token: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.token,
      ispaidfromgp: false,
      remote_id: parsedJson && parsedJson.remote_id,
      type: "REFUND",
      selected_payment_gateway: PaymentGatewaysEnum.AXIAMED,
      hash: ""
    };
    return paymentObject;
  }

  PaymentTypeRenderer = (params) => {
    return (params.data.selected_payment_gateway === PaymentGatewaysEnum.AXIAMED && params.data.type === "hpp") ? "" : (params.data.payment_type || params.data.card_type)
  }

  AmountValueRenderer = (params) => {
    return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
  }

  TypeValueRenderer = (params) => {
    return params.value ? params.value.toUpperCase() : ''
  }

  TransactionStatusRenderer = (params) => {
    return params.data.trans_status || params.data.host_response_description
  }

  CardNumberRenderer = (params) => {
    return params.data.masked_card_number || params.data.account_no
  }

  render() {
    const { classes, t } = this.props;
    const { data, SelectedPaymentGateway, isHidden, isButtonDisabled, selectedObject, accountValues, boxvalues } = this.state;

    const columnDefs = [
      { field: "firstname", headerName: t("Report.iPay.FirstName"), },
      { field: "lastname", headerName: t("Report.iPay.LastName") },
      {
        field: "store", headerName: t("Report.iPay.Store"), filter: true,
        filterParams: {
          values: accountValues.map(account => {
            return account.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "box", headerName: t("Report.iPay.Location"), filter: true,
        filterParams: {
          values: boxvalues.map(box => {
            return box.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      { field: "pucode", headerName: t("Report.iPay.PUCode") },
      { field: "transaction_id", headerName: t("Report.iPay.TransactionID"), cellRenderer: this.LinkValueRenderer },
      { field: "trans_status", headerName: t("Report.iPay.TransactionStatus"), cellRenderer: this.TransactionStatusRenderer },
      { field: "masked_card_number", headerName: t("Report.iPay.CardNumber"), cellRenderer: this.CardNumberRenderer },
      { field: "card_type", headerName: t("Report.iPay.CardType") },
      { field: "card_brand", headerName: t("Report.iPay.CardBrand") },
      { field: "entry_type", headerName: t("Report.iPay.EntryType") },
      { field: "reference_id", headerName: t("Report.iPay.ReferenceID"), filter: false },
      {
        field: "payment_date", headerName: t("Report.iPay.PaymentDateTime"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.iPay.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.iPay.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      { field: "payment_type", headerName: t("Report.iPay.PaymentType"), filter: false, cellRenderer: this.PaymentTypeRenderer },
      { field: "currency_code", headerName: t("Report.iPay.CurrencyCode") },
      { field: "approved_amt", headerName: t("Report.iPay.TotalAmount"), filter: false, cellRenderer: this.AmountValueRenderer },
      { field: "type", headerName: t("Report.iPay.Type"), cellRenderer: this.TypeValueRenderer },
    ];

    return (
      <div id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="alert-dialog-title">{`${this.state && this.state.selectedObject && this.state.selectedObject.username}'s ${t("Report.iPay.Popup.PaymentDetail")}`}</DialogTitle>
            <DialogContent>
              <Table aria-labelledby="tableTitle">
                {
                  this.returnReceiptDetails(this.state.selectedObject, classes)
                }
              </Table>
            </DialogContent>
            <DialogActions id="react-no-print">
              {SelectedPaymentGateway === PaymentGatewaysEnum.AXIAMED ? (
                <div>
                  {((selectedObject && selectedObject.type === 'refund') || (selectedObject && selectedObject.type === 'REFUND')) ? (
                    ("")
                  ) : <Button onClick={() => { this.handleConfirmRefundOpenOrClose() }} color="primary" className={classes.primaryButton}>
                    {t("Report.iPay.Popup.RefundButton")}
                  </Button>
                  }
                </div>
              ) : ("")}
              &nbsp;&nbsp;&nbsp;<Button onClick={() => { this.PrintDetails() }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.PrintButton")}
              </Button>
              <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>

          <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
              <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                <Tooltip key="clear-filters" title={t("Report.iPay.ClearFiltersTooltip")}>
                  <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                    <CloseIcon style={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip key="export-csv" title={t("Report.iPay.ExportCSV")}>
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label="ExportCSV"
                    onClick={() => { this.exportCSV() }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
          {accountValues.length && boxvalues.length ?
            <ReportsAGGrid
              columnDefs={columnDefs}
              sideBar={false}
              suppressMenuHide={true}
              rowData={data}
              defaultColDef={{
                flex: 1,
                minWidth: 150,
                floatingFilter: true,
                filter: 'agTextColumnFilter',
                filterParams: {
                  filterOptions: [{
                    displayKey: 'searchtext',
                    displayName: 'Search Text',
                    predicate: (cellValue) => cellValue
                  }],
                  maxNumConditions: 1,
                },
                resizable: true,
                sortable: true,
                menuTabs: ['generalMenuTab', 'columnsMenuTab'],
              }}
              onGridReady={this.onGridReady}
            />
            : null
          }
        </div>
        <Dialog
          open={this.state.confirmationForRefund || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'sm'}
        >
          <DialogTitle id="alert-dialog-title">Refund Confirmation</DialogTitle>
          <DialogContent>
            <Table aria-labelledby="tableTitle">
              {/*  */}
              {this.state && this.state.reversalConfirmationMessage}
            </Table>
          </DialogContent>
          <DialogActions id="react-no-print">
            {isHidden ? (
              <div>
                <Button disabled={isButtonDisabled} onClick={(e) => { this.handleConfirmRefundOpenOrClose(e) }} color="primary" className={classes.primaryButton}>
                  Ok
                </Button>
              </div>
            ) : (
              <div>
                <Button disabled={isButtonDisabled} onClick={() => { this.initRefund() }} color="primary" className={classes.primaryButton}>
                  Yes
                </Button>&nbsp;&nbsp;
                <Button disabled={isButtonDisabled} onClick={(e) => { this.handleConfirmRefundOpenOrClose(e) }} color="primary" className={classes.primaryButton}>
                  No
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/ipay_transaction/index.js